import { CIMSTags } from '../..'
import { PayItemTagsProps } from './types'

/**
 * renders a {@link CIMSTags} component for PayItemNoGeometry records
 *
 * @param props {@link PayItemTagsProps}
 */
const PayItemTags: React.FC<PayItemTagsProps> = ({ payItems }) => {
  return (
    <CIMSTags
      tags={payItems?.map(({ deleted, label }) => ({
        text: label,
        strikethrough: deleted,
      }))}
    />
  )
}

export default PayItemTags
